function GameHeader({ imagesArray, imagesCount, numbOfQuestions, resultsArray, isRight, displayed, onLogoClick }) {
    const segments = Array.from({ length: numbOfQuestions }, (_, i) => {
        if (imagesArray.length === 0) return 'unanswered';

        const image = imagesArray[i];
        if (!image) return 'unanswered';

        if (i < imagesCount) {
            // Past question - look up in resultsArray
            return resultsArray[image.id] ? 'correct' : 'wrong';
        }
        if (i === imagesCount && displayed) {
            // Current question, answer revealed
            return isRight ? 'correct' : 'wrong';
        }
        return 'unanswered';
    });

    return (
        <div className="px-4 pt-3 pb-2">
            <h2
                className="font-title text-2xl text-[#0F172A] text-center mb-2 cursor-pointer"
                onClick={onLogoClick}
            >
                Kid or Dog?
            </h2>
            <div className="flex gap-1">
                {segments.map((status, i) => (
                    <div
                        key={i}
                        className={`
                            h-2 flex-1 transition-colors duration-300
                            ${i === 0 ? 'rounded-l-full' : ''}
                            ${i === numbOfQuestions - 1 ? 'rounded-r-full' : ''}
                            ${status === 'correct' ? 'bg-emerald-400' : ''}
                            ${status === 'wrong' ? 'bg-red-400' : ''}
                            ${status === 'unanswered' ? 'bg-gray-200' : ''}
                        `}
                    />
                ))}
            </div>
        </div>
    );
}

export default GameHeader;
